import styled from '@emotion/styled';

import { fonts, colors } from '../../../app/styles/constants';

export default styled.h1`
  font-size: 20px;
  font-family: ${fonts.quicksand};
  color: ${colors.mutedText};
  text-align: center;
`;
